import { postText } from './api-service';

/**
 * Sends a request to reset candidate , candidate to reset is picked from authentication ticket passed with request. 
 */
export const resetCandidate = (): Promise<string> => postText('ResetCandidate', '');